import Trusted from './Trusted';

export default Trusted;
